module.exports = __webpack_public_path__ + "img/yjb_logo_login@3x.9b5bb126.png";